import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../../commn/Navbar";
import { Contact } from "../../home/Contact";
import "./Blogs.css";

// const newPath = window.location.pathname;
// if (newPath === "/blogs") {
//   fetch(
//     "https://api.countapi.xyz/update/159.223.218.132/272af60f-76ca-40f8-af83-7a26e8c1cdbe?amount=1"
//   );
// }

export const CBlogs = () => {
  const [item, setItem] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [viewCount, setViewCount] = useState(0);
  const [hasIncremented, setHasIncremented] = useState(false);
  const page = "blogs";

  useEffect(() => {
    try {
      axios.get("/api/blogs/get").then((res) => {
        const sorted = res.data.sort((a, b) => {
          // Sort newest first by _id (MongoDB ObjectIds are chronological)
          if (a._id > b._id) return -1;
          if (a._id < b._id) return 1;
          return 0;
        });
        setItem(sorted);
      });
    } catch (err) {
      console.log(err);
    }

    const fetchPageViews = async () => {
      try {
        const response = await fetch(`/api/pageView/${page}`);
        const data = await response.json();
        setViewCount(data.count);
      } catch (error) {
        console.error("Error fetching page view count:", error);
      }
    };

    const incrementPageView = async () => {
      try {
        await fetch(`/api/pageView/${page}/increment`, {
          method: 'POST',
        });
        setHasIncremented(true);
      } catch (error) {
        console.error("Error incrementing page view count:", error);
      }
    };

    if (!hasIncremented) {
      fetchPageViews();
      incrementPageView();
    } else {
      fetchPageViews();
    }
  }, [page, hasIncremented]);

  return (
    <div className="premium-blog-wrapper" style={{ minHeight: "100vh", paddingBottom: "4rem" }}>
      <Navbar />
      <div className="container mt-5 pt-5 pb-5">
        <div className="text-center mb-5">
          <h1 className="fw-bolder" style={{ color: "#ffffff", textShadow: "0 2px 4px rgba(0,0,0,0.5)" }}>Latest Blogs</h1>
        </div>
        {item.map((blogs) => {
            return (
              <section
                key={blogs._id}
                className="mx-auto mb-5"
                id="scroll-target"
                style={{ maxWidth: "1000px" }}
              >
                <div className="container px-3">
                  <div className="row g-0 premium-card align-items-stretch" style={{ minHeight: "320px" }}>
                    <div className="col-lg-8">
                      <img
                        className="blog-image-mask"
                        style={{
                          width: "100%",
                          height: "100%",
                          minHeight: "250px",
                          objectFit: "cover",
                          display: "block"
                        }}
                        src={blogs.image ? "/blogs/" + blogs.image : blogs.imageUrl}
                        alt={blogs.name}
                        onError={(e) => {
                          if (blogs.imageUrl && e.target.src !== blogs.imageUrl) {
                            e.target.src = blogs.imageUrl;
                          }
                        }}
                      />
                    </div>
                    <div className="col-lg-4 text-start premium-card-body">
                      <h3 className="premium-title">{blogs.name}</h3>
                      <div className="premium-meta">
                        <span className="me-3">{blogs.uploadername || "Admin"}</span>
                        <span>{blogs.date}</span>
                      </div>
                      <p className="premium-text">
                        {blogs.shortdesc}
                      </p>
                      <div className="d-flex align-items-center gap-3 mt-auto">
                        <Link to={`/blogs/${blogs._id}`} style={{ textDecoration: "none" }}>
                          <button className="premium-button premium-btn-primary">
                            Read More
                          </button>
                        </Link>
                        {blogs.sourceLink && (
                          <a href={blogs.sourceLink} target="_blank" rel="noreferrer" className="premium-button premium-btn-outline">
                            Original News Post
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      <Contact />
    </div>
  );
};
